import { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import SetupPortalPage from '../../components/setup/SetupPortalPage';
import BackToAgentSetupLink from '../../components/setup/BackToAgentSetupLink';
import AgentForm from '../../components/agents/AgentForm';
import { AGENT_SETUP_BASE } from '../../constants/setupRoadmapSteps';
import api from '../../API.js';
import styles from '../../styles/agents.module.css';

function AgentEdit() {
    const { agentId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [agent, setAgent] = useState(null);

    useEffect(() => {
        if (agentId) {
            fetchAgent();
        }
    }, [agentId]);

    const fetchAgent = async () => {
        try {
            setLoading(true);
            setError('');
            const response = await api.get(`agent/${agentId}`);
            
            if (response.status === 404) {
                setError('Agent not found. It may have been deleted.');
                setLoading(false);
                return;
            }
            
            if (response.status !== 200) {
                throw new Error(`Failed to fetch agent: ${response.status}`);
            }

            setAgent(response.data);
        } catch (err) {
            console.error('Error fetching agent:', err);
            setError('Failed to load agent: ' + (err.message || 'Unknown error'));
        } finally {
            setLoading(false);
        }
    };

    const handleUpdate = async (formData) => {
        try {
            const response = await api.put(`agent/${agentId}`, { body: formData });
            
            if (response.status !== 200) {
                let errorMessage = `HTTP error! status: ${response.status}`;
                if (response.data) {
                    if (typeof response.data === 'string') {
                        errorMessage = response.data;
                    } else if (response.data.message) {
                        errorMessage = response.data.message;
                    } else if (response.data.error) {
                        errorMessage = response.data.error;
                    }
                }
                throw new Error(errorMessage);
            }

            navigate(`${AGENT_SETUP_BASE}/manage`);
        } catch (err) {
            throw err;
        }
    };

    if (loading) {
        return (
            <SetupPortalPage>
                <div className={styles.loading}>Loading agent...</div>
            </SetupPortalPage>
        );
    }

    if (error && !agent) {
        return (
            <SetupPortalPage>
                <div className={styles.container}>
                    <div className={styles.error}>
                        {error}
                    </div>
                    <Link
                        to={`${AGENT_SETUP_BASE}/manage`}
                        className={styles.button}
                        style={{ marginTop: '1em', display: 'inline-block' }}
                    >
                        Back to Agents
                    </Link>
                </div>
            </SetupPortalPage>
        );
    }

    return (
        <SetupPortalPage>
            <div className={styles.container}>
                <div style={{ marginBottom: '2em' }}>
                    <BackToAgentSetupLink />
                </div>

                <h1>Edit Agent: {agent?.name}</h1>

                {error && (
                    <div className={styles.error}>
                        {error}
                    </div>
                )}

                {agent && (
                    <AgentForm
                        agent={agent}
                        onSubmit={handleUpdate}
                        onCancel={() => navigate(`${AGENT_SETUP_BASE}/manage`)}
                    />
                )}
            </div>
        </SetupPortalPage>
    );
}

export default AgentEdit;
